// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__2DiPf","checkboxInput":"Checkbox_checkboxInput__3bMSe","checkboxText":"Checkbox_checkboxText__1wFHX","checked":"Checkbox_checked__Qh3J7"};